import {DataTransferObjectValidation} from "../../../type/Types";
import {ShoppingPathJointReportReasonValueObject} from "../../vo/content/ShoppingPathJointReportReasonValueObject";


export namespace ShoppingPathJointReportReasonDataTransferObject {
    export type Post = {
        body: string
    }

    export namespace Post {
        export const description: Record<keyof Post, string> = ShoppingPathJointReportReasonValueObject.description

        export const validation: DataTransferObjectValidation<Post> = {
            body(o: string): string  {
               return o
            },
        }
    }

    export type Put = {
        body: string
    }

    export namespace Put {
        export const description: Record<keyof Put, string> = ShoppingPathJointReportReasonValueObject.description

        export const validation: DataTransferObjectValidation<Put> = {
            body(o: string): string  {
                return o
            },
        }
    }
}

